import React from 'react'
import styled from '@emotion/styled'
import logo from 'images/logo.gif'
import typography from 'utils/typography'
import { globalStyles } from 'utils/style'
import { Global } from '@emotion/react'
import { Link } from 'gatsby'

const { rhythm } = typography

const Container = styled.div`
  margin: 0 auto 50px;
  max-width: 700px;
  padding: ${rhythm(1 / 2)};
  background-color: white;
`

const Header = styled.header`
  padding: ${rhythm(1 / 2)};

  h1 {
    line-height: 0;
    margin: 0 0 ${rhythm(1 / 2)};

    img {
      margin: 0;
      width: 140px;
      height: 31px;
    }
  }
`

const Main = styled.main``

const Layout = ({ children }) => (
  <Container>
    <Global styles={globalStyles} />
    <Header>
      <h1>
        <Link to="/" title="drueck.net" rel="home">
          <img src={logo} alt="drueck.net" />
        </Link>
      </h1>
    </Header>
    <Main>{children}</Main>
  </Container>
)

export default Layout
